export enum CardBrand {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  UNDEFINED = 'UNDEFINED',
}
